import script from "./MobileUserMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileUserMenu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"MobileUserMenu.vue"]])

export default __exports__